export interface ReportModule {
  reportLogic: (result: object) => Promise<any>;
}

export const reportLoaders: Record<number, () => Promise<ReportModule>> = {
  1: () => import("./report-1"),
  2: () => import("./report-2"),
  3: () => import("./report-3"),
  4: () => import("./reporting-combined"),
  // add more as needed
};
